import { ReduxState } from '../../../../types';

/**
 * @param {ReduxState} state - The Redux state.
 * @returns {object} The Brownlow Tracker Player Modal state.
 */
export const playerModalSelector = (state) => state.brownlowTracker.playerModal;
